import type { MediaRequestEntry, MediaRequestStatus, RequestSeason } from '@tracearr/shared';
import { formatDate, formatDuration } from '@/lib/dateFormat';

/** i18next's TFunction can't statically verify these dynamically built keys; callers pass their real `t` through this shape. */
export type Translate = (key: string, vars?: Record<string, unknown>) => string;

const DECLINED_STATUSES: MediaRequestStatus[] = ['declined', 'failed'];

export function formatWait(
  waitMs: number | null,
  status: MediaRequestStatus,
  t: Translate
): string {
  if (DECLINED_STATUSES.includes(status)) return t('requests.wait.declined');
  if (waitMs === null) return t('requests.wait.pending');
  return formatDuration(waitMs, { style: 'compactDays' });
}

export function formatSeasons(seasons: RequestSeason[] | null, t: Translate): string | null {
  if (seasons === null) return null;
  if (seasons.length === 0) return t('requests.seasons.all');
  return seasons
    .map((season) => season.seasonNumber)
    .sort((a, b) => a - b)
    .map((number) => t('requests.seasons.item', { number }))
    .join(', ');
}

export function heroRequestLine(entry: MediaRequestEntry, name: string, t: Translate): string {
  const date = formatDate(new Date(entry.requestedAt), { dateStyle: 'medium' });
  const tail = DECLINED_STATUSES.includes(entry.status)
    ? t('requests.wait.declined')
    : entry.waitMs === null
      ? t('requests.hero.waiting')
      : t('requests.hero.landed', { wait: formatDuration(entry.waitMs, { style: 'compactDays' }) });
  return t('requests.hero.line', { name, date, tail });
}
